const ImmovableTypeEnum = {
  LAND: 1,
  BUILDING: 2,
  APARTMENT: 3,
  SHOP: 4,
  OTHER: 5,
};

export default ImmovableTypeEnum;
